import { EventEmitterService } from '@core/services/event-emitter.service';
import { Component, OnInit} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { GameCategoryHttpService } from '@core/services/game-category-http.service';
import { map, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { LoginModalComponent } from '@shared/login-modal/login-modal.component';
import { CountDownDetailsComponent } from '@shared/count-down-details/count-down-details.component';
import { GameListHttpService } from '@core/services/game-list-http.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-jackpot-slider',
  templateUrl: './jackpot-slider.component.html',
  styleUrls: ['./jackpot-slider.component.scss'],
})
export class JackpotSliderComponent implements OnInit {

  odometerConfig = {
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    auto: true,
  }

  availableProvider = JSON.parse(localStorage.getItem('available_providers'));
  SGisActive = false; 
  PTisActive = false;

  customOptionsJacpot: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    items: 1,
    nav: false,
    animateOut: 'animate__animated animate__slideOutDown',
  };

  gameCodeByJacpot = {
    MGC:  'S-LB01',
    FUFU: 'S-FO01',
    ADV:  'S-PO02',
    GJ:   'S-DG03',
    CJ:   'S-EG02',
  };

  gameCodeByJacpotPostion = [
    'MGC', // 1
    'FUFU', // 2
    'ADV', // 3
    'GJ', // 4
    'CJ' // 5
  ];

  gameCodeByJacpotPt = {
    'jpgt6-1':  'jpgt',
    'ashlcl-1': 'ashlcl',
    'ashbob-1':  'ashbob',
    cnpr4:   'cnpr',
    kfp:   'kfp',
    'dcjp-4' : 'gpas_etpop_pop',
    'pisa' : 'pisa',
    'bjp-4' : 'gpas_bprog_pop',
  };

  gameCodeByJacpotPostionPt = [
    'jpgt6-1', // 1
    // 'ashlcl-1', // 2
    // 'ashbob-1', // 3
    'cnpr4', // 4
    // 'kfp', // 5
    'dcjp-4', // 6
    'pisa', // 7
    'bjp-4', // 8
  ];

  jackpot = [];
  gameList  = {};
  gameListPt = {};
  ptgamelistcheck = false

  constructor(
    private eventEmitterService: EventEmitterService,
    private router: Router,
    private gameCategoryHttpService: GameCategoryHttpService,
    public dialog: MatDialog,
    private gameListHttpService: GameListHttpService
  ) { 

  }

  ngOnInit() {

    if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'SG')) this.SGisActive = true;
    if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI') || !environment.production ) this.PTisActive = true;
    this.getGameList();
    this.getGameListPT();
    //for testing number update
    // var plus = 0;
    this.eventEmitterService.jackpotDataEventEmitter.subscribe(data => {
      data = this.formDataArray(data['jackpot']);
      if(!this.availableProvider) {
        this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
        this.SGisActive = true;
        this.PTisActive = true;
      }

      if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'SG') && this.SGisActive == false) this.SGisActive = true;
      if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI' && this.PTisActive == false ) || !environment.production ) this.PTisActive = true;
      
      if(this.jackpot.length == 0) {
        this.jackpot = data;
      }else{
        // update only amount, instead array due to the slider will re-render problem
        if(this.jackpot.length > 0 && data.length  > 0){
          let jackpotlist = this.jackpot;
          Object.keys(jackpotlist).forEach(function (key) {
            //for testing number update
            // plus = plus + 5;
            // data[key]['amount']['MYR'] = data[key]['amount']['MYR'] + plus;  

            // only amount different only will update
            if( JSON.stringify(data[key]['amount']) !== JSON.stringify(jackpotlist[key]['amount']) ){
              jackpotlist[key]['amount'] = data[key]['amount'];
            }
          });
          this.jackpot = jackpotlist;
        }
      }
    });

  }

  getOffset(el: any) {
    el = el.getBoundingClientRect();
    return {
      left: el.left + window.scrollX,
      top: el.top + window.scrollY,
      bottom: el.top + window.scrollY
    };
  }

  scroll() {
    const scrollTo = document.getElementById('content');
    const topHight = this.getOffset(scrollTo).top;
    window.scrollTo(0, topHight);
  }


  onLaunchGame(data: string, gameProvider) {

    if(gameProvider == 'SG'){
      var gameCode = this.gameList[this.gameCodeByJacpot[data]]['code'];
      data = 'Launch|SG||'+gameCode;
    }else{
      var gameCode = this.gameListPt[this.removeFormat(this.gameCodeByJacpotPt[data])]['code'];
      data = 'Launch|PTI||'+gameCode;
    }

    // E.g data : Launch|game_provider_code|subCategoryCode|game_code, Launch|EZ|roulette|481000
    let datas = data.split('|');
    this.gameCategoryHttpService.getGames('SL').pipe(
      map(res => res.find(x => x.game_provider_code === datas[1]))
    ).subscribe((gameProvider: any) => {
      // To update the params on the URL
      const dateEnd = Date.parse(gameProvider.maintain_end);
      const dateNow = new Date().getTime();

      if (localStorage.getItem('user_data') === null) {
        this.dialog.open(LoginModalComponent, { width: 'auto' });
      }
      else if (gameProvider.maintenance === 1 && dateEnd > dateNow) {
        this.dialog.open(CountDownDetailsComponent, {
          width: 'auto',
          data: {
            dateEnd: gameProvider.maintain_end,
            name: gameProvider.game_provider_name,
            time: gameProvider.maintain_time_left,
          }
        });
      }
      //maintenance with no end date
      else if (gameProvider.maintenance === 1 && gameProvider.maintain_end === '') {
        this.dialog.open(CountDownDetailsComponent, {
          width: 'auto',
          data: {
            name: gameProvider.game_provider_name,
            time: gameProvider.maintain_time_left,
          }
        });
      } else {
        localStorage.setItem('gameProviderCode', gameProvider.game_provider_code);
        localStorage.setItem('gameCategory', 'SL');
        localStorage.setItem('gameProviderId', gameProvider.game_provider_id);
        datas[2] !== undefined ? localStorage.setItem('subCategoryCode', datas[2]) : localStorage.removeItem('subCategoryCode');
        datas[3] !== undefined ? localStorage.setItem('gameCode', datas[3]) : localStorage.removeItem('gameCode');
        localStorage.setItem('lobbyUrl', location.href);
        // localStorage.setItem('isPlayTechClicked', (gameProvider.game_provider_code === "PTI").toString());
        localStorage.setItem('gameMode', 'real');
        this.router.navigate([]).then(() => { window.open('/launch', '_blank'); });
      }
    })

  }

  onGetCurrencyCode() {
    let currency_code =  null;

    if (localStorage.getItem('country_code')?.toUpperCase() == 'MY') {
      currency_code = 'MYR';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'SG') {
      currency_code = 'SGD';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'ID') {
      currency_code = 'IDR';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'TH') {
      currency_code = 'THB';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'VN') {
      currency_code = 'VND';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'PH') {
      currency_code = 'PHP';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'AU') {
      currency_code = 'AUD';
    }

    return currency_code;
  }

  transferAmount(data){
    let amount = +parseFloat(data).toFixed(2);

    //Workaround to deal with floating point arithmetic issue
    if (Math.round(amount * 100) % 10 == 0) {
      amount = amount + 0.01
    }

    return amount;
  }

  getGameList() {
      var games = {};
      // hard code to get Spade game,slot gamelist
      this.gameListHttpService.getGamesBy('SG', 'SL').pipe(
        tap(res => {
          Object.keys(res).forEach(function (key) {
            if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
          });
          this.gameList = games;
        })
      ).subscribe();
  }

  getGameListPT() {
    var games = {};
    // hard code to get Playtech game , for qa testing
    if (!environment.production) {
      games['jpgt'] = {
          "code":  "jpgt",
          "GameProviderCode" : "PTI"
      };
      games['ashlcl'] = {
        "code":  "ashlcl",
        "GameProviderCode" : "PTI"
      };
      games['cnpr'] = {
          "code":  "cnpr",
          "GameProviderCode" : "PTI"
      };
      games['kfp'] = {
        "code":  "kfp",
        "GameProviderCode" : "PTI"
      };
      games['ashbob'] = {
        "code":  "ashbob",
        "GameProviderCode" : "PTI"
      };
      games['gpas_etpop_pop'] = {
        "code":  "gpas_etpop_pop",
        "GameProviderCode" : "PTI"
      };
      games['pisa'] = {
        "code":  "pisa",
        "GameProviderCode" : "PTI"
      };
      games['gpas_bprog_pop'] = {
        "code":  "gpas_bprog_pop",
        "GameProviderCode" : "PTI"
      };

      this.gameListPt = games;

    }else{
      this.gameListHttpService.getGamesBy('PTI', 'SL').pipe(
      tap(res => {
        Object.keys(res).forEach(function (key) {
          if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
        });
        this.gameListPt = games;
      })
    ).subscribe();
    }

  }

  formDataArray(data) {
    var games = [];
    Object.keys(data).forEach(element => {
      Object.keys(data[element]['data']).forEach(element2 => {
        data[element]['data'][element2]['GameProviderCode'] = element;
        games.push(data[element]['data'][element2]);
      }); 
    });
    return games;
  }

  removeFormat(data){
    return data.replace('-1', '') as string;
  }

  checkPTgame(){

    if(this.ptgamelistcheck){
      return true;
    }
    var checkPt = false
    if( this.jackpot && this.jackpot.length > 0 ){
      var jackpotlist = this.jackpot;
      var gameCodeByJacpotPostionPt  = this.gameCodeByJacpotPostionPt;
      
      Object.keys(gameCodeByJacpotPostionPt).forEach(function (key) {
        Object.keys(jackpotlist).forEach(element2 => {
          if(jackpotlist[element2]['code'] == gameCodeByJacpotPostionPt[key]){
            checkPt = true;
          }
        }); 
      });
    }

    if(checkPt){
      this.ptgamelistcheck = true;
      return true;
    }
  
    return false;
  }
}
